import { PopupComponent, classes$8, selectors$b } from './popup-component.js';

class PopupNewsletter extends PopupComponent {
  constructor() {
    super();
    this.form = this.popup.querySelector(selectors$b.newsletterForm);
    this.heading = this.popup.querySelector(selectors$b.newsletterHeading);
    this.newsletterField = this.popup.querySelector(selectors$b.newsletterField);
  }

  connectedCallback() {
    const cookieExists = this.cookie?.read() !== false;
    const submissionSuccess = window.location.search.indexOf('?customer_posted=true') !== -1;
    const classesString = [...this.classList].toString();
    const isPositionBottom = classesString.includes(classes$8.bottom);
    const targetMobile = this.popup.classList.contains(classes$8.mobile);
    const targetDesktop = this.popup.classList.contains(classes$8.desktop);
    const isMobileView = theme.isMobile;

    let targetMatches = true;

    if ((targetMobile && !isMobileView) || (targetDesktop && isMobileView)) {
      targetMatches = false;
    }

    if (!targetMatches) {
      super.a11y.removeTrapFocus();
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      return;
    }

    if (!cookieExists || window.Shopify.designMode) {
      if (!window.Shopify.designMode && !window.location.pathname.endsWith('/challenge')) {
        super.showPopupEvents();
      }

      if (this.form && this.form.classList.contains(classes$8.success)) {
        super.popupOpen();
        this.cookie.write();
      }

      this.popup.addEventListener('theme:popup:onclose', () => this.cookie.write());
    }

    if (submissionSuccess) {
      this.delay = 0;
    }

    if (!cookieExists || window.Shopify.designMode) {
      this.show();

      if (this.form.classList.contains(classes$8.success)) {
        this.popupOpen();
        this.cookie.write();
      }
    }

    if (isPositionBottom) {
      this.observeCartBar();
    }
  }

  show() {
    if (!window.location.pathname.endsWith('/challenge')) {
      if (!window.Shopify.designMode) {
        super.showPopupEvents();
      } else {
        super.popupOpen();
      }
    }

    this.showForm();
    this.inputField();

    this.popup.addEventListener('theme:popup:onclose', () => this.cookie.write());
  }

  observeCartBar() {
    this.cartBar = document.getElementById(selectors$b.cartBar);

    if (!this.cartBar) return;

    const config = { attributes: true, childList: false, subtree: false };
    let isVisible = this.cartBar.classList.contains(classes$8.isVisible);
    document.body.classList.toggle(classes$8.cartBarVisible, isVisible);

    // Callback function to execute when mutations are observed
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          isVisible = mutation.target.classList.contains(classes$8.isVisible);
          document.body.classList.toggle(classes$8.cartBarVisible, isVisible);
        }
      }
    };

    this.observer = new MutationObserver(callback);
    this.observer.observe(this.cartBar, config);
  }

  showForm() {
    this.heading?.addEventListener('click', (event) => {
      event.preventDefault();

      this.heading.classList.add(classes$8.hidden);
      this.form.classList.remove(classes$8.hidden);
      this.newsletterField.focus();
    });

    this.heading?.addEventListener('keyup', (event) => {
      if (event.code === 'Enter') {
        this.heading.dispatchEvent(new Event('click'));
      }
    });
  }

  inputField() {
    const setClass = () => {
      // Reset timer if exists and is active
      if (this.resetClassTimer) {
        clearTimeout(this.resetClassTimer);
      }

      if (this.newsletterField.value !== '') {
        this.popup.classList.add(classes$8.hasValue);
      }
    };

    const unsetClass = () => {
      // Reset timer if exists and is active
      if (this.resetClassTimer) {
        clearTimeout(this.resetClassTimer);
      }

      // Reset class
      this.resetClassTimer = setTimeout(() => {
        this.popup.classList.remove(classes$8.hasValue);
      }, 2000);
    };

    this.newsletterField.addEventListener('input', setClass);
    this.newsletterField.addEventListener('focus', setClass);
    this.newsletterField.addEventListener('focusout', unsetClass);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('popup-newsletter')) {
  customElements.define('popup-newsletter', PopupNewsletter);
}
